import { UserIcon } from 'assets/icons';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { StarActiveIcon } from '../../assets/icons'
import { Button, Select } from 'components';
import { ReportsService } from 'services';
import moment from 'moment';
import { Globals } from 'utils';
import { useHistory } from 'react-router-dom';



const chartLocales = {
	defaultLocale: 'es',
	locales: [{
		name: 'es',
		options: {
			months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			shortDays: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
		}
	}],
}

const Home = () => {
	return (
		<section id='admin-home'>
			<UsersRegisters />
			<Appoinments />
			<Ratings />
			<Plans />

		</section>
	)
}


const UsersRegisters = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [state, setState] = useState<any>({
		series: [],
		options: {
			legend: {
				show: false
			},
			chart: {
				type: 'donut',
			},
			colors: ['#7f00b2', '#77dd77', '#19B6D1'],
			labels: ['Médicos', 'Usuarios', 'Empresas'],
			dataLabels: {
				enabled: false
			},
			responsive: [{
				breakpoint: 480,
				options: {
					chart: {
						width: 100
					},
					legend: {
						show: false
					}
				}
			}]
		},
	});


	useEffect(() => {
		getData()
	}, [])

	const getData = async () => {
		const res = await ReportsService.userAvg() as any
		setState({
			...state,
			series: res?.doctors > 0 && res?.patients > 0 && res?.companies > 0 ? [res?.doctors, res?.patients, res?.companies] : []
		})
	}


	return (
		<div className='register-users'>
			<div className="card">
				<h3 className='background-title'>Usuarios registrados</h3>
				<div className="body">
					{
						state.series.length > 0
							? (
								<>
									<div className='chart'>
										<ReactApexChart options={state.options} series={state.series} type="donut" />
									</div>
									<ul>
										<div>
											<li className='purple'>Médicos</li>
											<p className='percentage'>%{state.series[0]}</p>
										</div>
										<div>
											<li className='green'>Pacientes</li>
											<p className='percentage'>%{state.series[1]}</p>
										</div>
										<div>
											<li className='blue'>Empresas</li>
											<p className='percentage'>%{state.series[2]}</p>
										</div>
									</ul>
								</>
							)
							: <p className='empty-message'>No hay usuarios registrados</p>
					}
				</div>
			</div>

		</div>
	)
}


const Appoinments = () => {

	const [state, setState] = useState<any>({
		series: [],
		options: {
			chart: {
				...chartLocales,
				height: 350,
				type: 'line',
				toolbar: {
					show: false
				},
				zoom: {
					enabled: false
				},
				pan: {
					enabled: false
				},
			},
			colors: ['#19b6d1', '#779a0a',],
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'straight'
			},
			yaxis: {
				title: {
					text: 'Consultas'
				},
				min: 0,
				max: 2,
				tickAmount: 2,
				labels: {
					formatter: function (value: any) {
						return Math.round(value);
					}
				}
			},
			xaxis: {
				type: 'datetime',
				labels: {
					format: 'dd MMM'
				}
			},
		},
	});


	useEffect(() => {
		getData()
	}, [])

	const getData = async () => {
		const res = await ReportsService.appoinments() as any

		if (res?.face_to_face.length === 0 && res?.online.length === 0) return

		// Valor máximo de quantity en ambos arreglos
		const maxFaceToFace = Math.max(...res.face_to_face.map((item: any) => item.quantity));
		const maxOnline = Math.max(...res.online.map((item: any) => item.quantity));
		const maxQuantity = Math.max(maxFaceToFace, maxOnline);

		// Calculamos un tickAmount apropiado
		const tickAmount = Math.ceil(maxQuantity / 5);

		setState({
			...state,
			options: {
				...state.options,
				yaxis: {
					...state.options.yaxis,
					max: maxQuantity,
					tickAmount: tickAmount,
				}
			},
			series: [
				{
					name: 'Consultas presenciales',
					data: res.face_to_face.map((item: any) => ({ x: new Date(item.date), y: item.quantity }))
				},
				{
					name: 'Consultas online',
					data: res.online.map((item: any) => ({ x: new Date(item.date), y: item.quantity }))
				}
			]
		})
	}



	return (
		<div className='appoinments'>
			<div className="card">
				<h3 className='background-title'>Consultas</h3>
				{
					state.series.length > 0
						? <ReactApexChart options={state.options} series={state.series} type="line" height={270} />
						: <p className='empty-message'>No hay consultas registradas</p>
				}
			</div>
		</div>
	)
}


const Ratings = () => {
	const [data, setData] = useState<any>([]);
	const history = useHistory()

	useEffect(() => {
		getData()
	}, [])

	const getData = async () => {
		const res = await ReportsService.ratings() as any
		setData(res)
	}

	const handleNavigate = () => history.push('/admin/ratings')

	return (
		<div className='ratings'>
			<div className="card">
				<div className='header-title'>
					<h3 className='title'>Calificación</h3>
					<Button onClick={handleNavigate}>Ver más</Button>
				</div>
				<div className='body'>
					<div className='header'>
						<p>Médico</p>
						<p>Especialidad</p>
						<p>Calificación</p>
					</div>
					<div className='table'>
						{
							data.length > 0
								? data.map((item: any, index: number) => {

									console.log(item)
									const photo = item?.photo ? Globals.fromStorage(item?.photo) : null

									return (
										<div className='row' key={index}>
											<div className='cell'>
												<div className='user'>
													<div className='user-photo'>
														{
															photo
																? <img src={photo} alt="Usuario" onError={(e: any) => {
																	e.target.src = UserIcon
																	e.target.classList.add('invert-image')
																}} />
																: <img src={UserIcon} alt="Usuario" className="invert-image" />
														}
													</div>
													<p>{item?.full_name}</p>
												</div>
											</div>
											<div className='cell'>
												<p>{item?.specialty?.name}</p>
											</div>
											<div className='cell' style={{ alignItems: 'center', gap: '10px' }}>
												<span>{parseFloat(item?.rating).toFixed(1)}</span>
												<div className='rating'>
													{[...Array(Math.floor(item.rating))].map((el) => (
														<img src={StarActiveIcon} alt='rating' />
													))}
												</div>
											</div>
										</div>
									)
								})
								: <p className='empty-message'>No se han registrado calificaciones</p>
						}
					</div>
				</div>
			</div>
		</div>
	)
}




const monthOptions = moment.months().map((month, index) => ({
	value: `${index + 1}`,
	label: month
}));


const Plans = () => {
	const [selectedMonth, setSelectedMonth] = useState(moment().month() + 1);
	const [state, setState] = useState<any>({
		series: [],
		options: {
			chart: {
				...chartLocales,
				zoom: {
					enabled: false
				},
				pan: {
					enabled: false
				},
				height: 350,
				type: 'line',
				toolbar: {
					show: false
				}
			},
			colors: ['#19b6d1', '#779a0a', '#40005a', '#7f00b2', '#d20b06', '#FFC107', '#46fca5', '#0E2954', '#099896'],
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'straight'
			},
			xaxis: {
				type: 'datetime',
				labels: {
					format: 'dd MMM'
				}
			},
		},
	});


	useEffect(() => {
		getData()
	}, [selectedMonth])

	const getData = async () => {
		const year = moment().year();
		const startOfMonth = moment(`${year}-${selectedMonth}-01`).startOf('month');
		const endOfMonth = moment(`${year}-${selectedMonth}-01`).endOf('month');
		const startOfMonthFormatted = startOfMonth.format('YYYY-MM-DD');


		const res = await ReportsService.plansChart({ date: startOfMonthFormatted }) as any

		// Obtener el máximo valor de `quantity` de todos los planes
		const maxQuantity = Math.max(...Object.values(res).flatMap((plan: any) => plan.map((item: any) => item.quantity)));

		// Definir tickAmount basado en el máximo valor
		const tickAmount = maxQuantity > 0 ? Math.ceil(maxQuantity / 5) : 1;


		const seriesData = Object.keys(res).map(plan => {
			if (res[plan]?.length < 1) return null
			return {
				name: plan,
				data: res[plan].map((item: any) => ({
					x: new Date(item.date),
					y: item.quantity
				}))
			}
		}).filter(Boolean);

		setState({
			...state,
			series: seriesData,
			options: {
				...state.options,
				xaxis: {
					...state.options.xaxis,
					min: startOfMonth.valueOf(),
				},
				yaxis: {
					...state.options.yaxis,
					max: maxQuantity,
					tickAmount: tickAmount,
				}
			}
		});
	}

	return (
		<div className='plans'>
			<div className="card">
				<h3 className='title'>Planes adquiridos</h3>
				<div className="body">
					<Select
						name='months'
						className='select-filter'
						options={monthOptions}
						value={String(selectedMonth)}
						onChange={(option) => setSelectedMonth(option?.target?.value || moment().month() + 1)}
					/>

					{
						state.series.length > 0
							? <ReactApexChart options={state.options} series={state.series} type="line" height={270} />
							: <p className='empty-message '>No hay planes adquiridos para este mes</p>
					}

				</div>
			</div>
		</div>
	)
}

export default Home;